export const GET_USER_LOCATION_DATA_START =
  'GET_USER_LOCATION_DATA_START';
export const GET_USER_LOCATION_DATA_SUCCESS =
  'GET_USER_LOCATION_DATA_SUCCESS';
export const GET_USER_LOCATION_DATA_ERROR =
  'GET_USER_LOCATION_DATA_ERROR';
export const GET_USER_LOCATION_DATA_END =
  'GET_COUNTRY_CURRENCIES_END';
